// eslint-disable-next-line no-restricted-imports
import { InvoiceFragment } from 'api/generated/graphql';
import { parseFileEntity } from 'api/helpers/client/parseEntity/parseFileEntity';
import { InvoiceEntity } from 'api/types/entity';
import { lodash } from 'helpers';
import { Maybe } from 'types/maybe';

export const parseInvoiceEntity = (
  invoice: Maybe<InvoiceFragment>
): InvoiceEntity | undefined => {
  if (!invoice) {
    return undefined;
  }

  return {
    file: invoice.privateFile
      ? parseFileEntity(invoice.privateFile)
      : undefined,
    paymentConfirmationFiles: lodash
      .compact(invoice.paymentConfirmationFiles)
      .map(parseFileEntity),
  };
};
